import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  UpdateWindowType,
  syncDesignViewportSize,
} from '../../utils/UtilsFunction';

export const update_window_type = createAsyncThunk(
  'update_window_type',
  async (data) => {
    const newData = UpdateWindowType(data);
    return newData;
  }
);

const initialState = {
  window_type: 'design',
  update_state: [],
  window_size: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
  preview_type: 'default',
};
const windowTypeSlice = createSlice({
  name: 'update_window',
  initialState,
  reducers: {
    update_window_size_by_key: (state, action) => {
      const { value, key } = action.payload;
      state.window_size = {
        ...state.window_size,
        [key]: value,
      };
    },
    update_full_window_size: (state, action) => {
      const data = action.payload;
      state.window_size = data;
    },
    update_preview_type: (state, action) => {
      const type = action.payload;
      state.preview_type = type;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(update_window_type.fulfilled, (state, action) => {
      const { type, current_type, updatedArray, scene } = action.payload;

      if (type == current_type) {
        return;
      } else if (
        (type === 'preview' && current_type == 'code') ||
        (current_type == 'preview' && type == 'code')
      ) {
        state.window_type = type;
        return;
      } else if (
        (type == 'preview' || type == 'code') &&
        current_type == 'design'
      ) {
        state.update_state = updatedArray;
      } else if (type == 'design' && current_type != 'design') {
        state.update_state.forEach((val) => {
          scene.add(val);
        });
        // Restore natural full-window canvas — framed preview styles stretch design.
        syncDesignViewportSize();
      }
      state.window_type = type;
    });
  },
});
export const {
  update_window_size_by_key,
  update_full_window_size,
  update_preview_type,
} = windowTypeSlice.actions;
export default windowTypeSlice.reducer;
